<body>
    <div class="grid-overlay">
        <app-page-header></app-page-header>

        <div class="general-data">
            <h1>{{ 'customerInvoiceDetail.generalData' | translate }}</h1>
            <!-- <form [formGroup]="form" > -->
            <div class="grid">
                <div class="left">

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.client' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.customer?.name_customer  + ' ' + invoice?.customer?.lastName_customer || '-' }}">
                    </div>

                   <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.code' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.customer?.code_customer || '-'}}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.contract' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.customer_has_plan?.contractNumber_Plan || '-'}}">
                    </div>


                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.originalTotal' | translate }} ({{ currency }})</label>
                        <input type="text" readonly   value="{{ formatMoney(invoice?.total_invoice) }}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.refundedAmount' | translate }} ({{ currency }})</label>
                        <input type="text" readonly   value="{{ formatMoney(invoice?.refundedAmount) }}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.netCollectedAmount' | translate }} ({{ currency }})</label>
                        <input type="text" readonly   value="{{ formatNetCollected() }}">
                    </div>

                    <p class="financial-summary-hint">{{ 'customerInvoiceDetail.fields.netExcludesPendingHint' | translate }}</p>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.created' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.dateCreated_invoice || '-'}}">
                    </div>
                  

                </div>


                <div class="right">

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.dni' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.customer?.identifier_customer || '-'}}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.plan' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.customer_has_plan?.plan?.name_plan || '-'}}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.status' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.status_invoice || '-'}}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.balance' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.balance_invoice || '-'}}">
                    </div>

                    <div class="items">
                        <label for="name">{{ 'customerInvoiceDetail.fields.updated' | translate }}</label>
                        <input type="text" readonly   value="{{ invoice?.updatedAt || '-'}}">
                    </div>
                   
                </div>
            </div>
        </div>

        <div class="reports-data refunds-history">

            <h1>{{ 'customerInvoiceDetail.refunds.title' | translate }}</h1>

            @if (refundsLoading) {
                <div class="refund-loading-state">{{ 'customerInvoiceDetail.refunds.loading' | translate }}</div>
            }

            @if (refundsLoadError && !refundsLoading) {
                <div class="refund-error-state">{{ 'customerInvoiceDetail.refunds.loadError' | translate }}</div>
            }

            @if (showLegacyRefundEmptyState()) {
                <div class="refund-empty-state">{{ 'customerInvoiceDetail.refunds.legacyEmpty' | translate }}</div>
            }

            @if (!refundsLoading && !refundsLoadError && refunds.length === 0 && !showLegacyRefundEmptyState()) {
                <div class="refund-empty-state">{{ 'customerInvoiceDetail.refunds.empty' | translate }}</div>
            }

            @if (!refundsLoading && !refundsLoadError && refunds.length > 0) {
                <div class="refunds-table-wrapper">
                    <mat-table [dataSource]="refundDataSource">

                        <ng-container matColumnDef="createdAt">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.createdAt' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.createdAt' | translate"> {{ row.createdAt || '—' }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.amount' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.amount' | translate"> {{ formatMoney(row.amount) }} {{ row.currency }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="refundType">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.type' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.type' | translate">
                                @if (refundTypeKey(row.refundType); as typeKey) {
                                    {{ typeKey | translate }}
                                } @else {
                                    —
                                }
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.status' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.status' | translate">
                                <span class="refund-status refund-status--{{ refundStatusClass(row.status) }}">{{ refundStatusKey(row.status) | translate }}</span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="authorizationNumber">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.authorizationNumber' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.authorizationNumber' | translate"> {{ row.authorizationNumber || ('customerInvoiceDetail.refundReceipt.unavailable' | translate) }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="resolvedAt">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.resolvedAt' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.resolvedAt' | translate"> {{ row.resolvedAt || '—' }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="processorRefundId">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.refunds.columns.processorReference' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.refunds.columns.processorReference' | translate"> {{ row.processorRefundId || '—' }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.payments.columns.actions' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" [attr.data-label]="'customerInvoiceDetail.payments.columns.actions' | translate">
                                @if (canShowRefundReceipt(row)) {
                                  <button
                                    mat-icon-button
                                    type="button"
                                    class="refund-receipt-button"
                                    [attr.aria-label]="'customerInvoiceDetail.payments.viewRefundReceipt' | translate"
                                    [matTooltip]="'customerInvoiceDetail.payments.viewRefundReceipt' | translate"
                                    matTooltipPosition="above"
                                    (click)="openRefundReceiptFromHistory(row)">
                                    <mat-icon>description</mat-icon>
                                  </button>
                                }
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="refundDisplayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: refundDisplayedColumns;"></mat-row>
                    </mat-table>
                    <mat-paginator showFirstLastButtons
                            [length]="refundTableService.pager.totalEntities"
                            [pageIndex]="refundTableService.pager.pageIndex"
                            [pageSize]="refundTableService.pager.pageSize"
                            [pageSizeOptions]="[20, 50, 100]"
                            (page)="listRefunds($event)">
                    </mat-paginator>
                </div>
            }

        </div>


        <div class="reports-data">
            
            <h1>{{ 'customerInvoiceDetail.payments.title' | translate }}</h1>
            <div style="padding-top: 2em;">
                <div class="payments-table-wrapper">
                <mat-table class="payments-table" [dataSource]="dataSource" matSort  >
                                 
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.payments.columns.id' | translate }} </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="id"> {{row.id}} </mat-cell>
                      </ng-container>
                  
                      <ng-container matColumnDef="description_payment">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.payments.columns.description' | translate }} </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="description_payment"><span class="payment-description" [matTooltip]="row.description_payment">{{row.description_payment}}</span></mat-cell>
                      </ng-container>
  
                      <ng-container matColumnDef="resultStatus_payment">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.payments.columns.status' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="resultStatus_payment"> {{row.resultStatus_payment}} </mat-cell>
                        </ng-container>
  
                        <ng-container matColumnDef="dates">
                          <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.payments.columns.dates' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="dates">
                            <div class="payment-two-lines">
                              <div class="payment-code-line"><span class="payment-label">{{ 'customerInvoiceDetail.payments.labels.transactionShort' | translate }}</span> {{row.transactionDate || 'N/A'}}</div>
                              <div class="payment-code-line"><span class="payment-label">{{ 'customerInvoiceDetail.payments.labels.createdShort' | translate }}</span> {{row.dateCreated_payment || 'N/A'}}</div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="card">
                            <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.payments.columns.card' | translate }} </mat-header-cell>
                            <mat-cell *matCellDef="let row" data-label="card">
                                <div class="payment-two-lines">
                                    <span>{{row.cardLast4}}</span>
                                    @if (row.cardBrand) {
                                        <span class="payment-label payment-card-brand">{{row.cardBrand}}</span>
                                    }
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="transaction">
                          <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.payments.columns.transactionAuth' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="transaction">
                            <div class="payment-two-lines">
                              <div class="payment-code-line">
                                <span class="payment-label">{{ 'customerInvoiceDetail.payments.labels.transactionShort' | translate }}</span>
                                <span class="payment-code" [matTooltip]="row.transactionId">{{row.transactionId || 'N/A'}}</span>
                                @if (row.transactionId) {
                                  <button mat-icon-button type="button" class="payment-copy-button"
                                    [attr.aria-label]="'customerInvoiceDetail.refundReceipt.copy' | translate"
                                    [matTooltip]="'customerInvoiceDetail.refundReceipt.copy' | translate"
                                    (click)="copyValue(row.transactionId)">
                                    <mat-icon>content_copy</mat-icon>
                                  </button>
                                }
                              </div>
                              <div class="payment-code-line">
                                <span class="payment-label">{{ 'customerInvoiceDetail.payments.labels.auth' | translate }}</span>
                                <span class="payment-code" [matTooltip]="row.authorizationNumber">{{row.authorizationNumber || 'N/A'}}</span>
                                @if (row.authorizationNumber) {
                                  <button mat-icon-button type="button" class="payment-copy-button"
                                    [attr.aria-label]="'customerInvoiceDetail.refundReceipt.copy' | translate"
                                    [matTooltip]="'customerInvoiceDetail.refundReceipt.copy' | translate"
                                    (click)="copyValue(row.authorizationNumber)">
                                    <mat-icon>content_copy</mat-icon>
                                  </button>
                                }
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                          <ng-container matColumnDef="transactionRefundId">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.payments.columns.refundId' | translate }}</mat-header-cell>
                            <mat-cell *matCellDef="let row" data-label="transactionRefundId"> {{row.transactionRefundId}} </mat-cell>
                          </ng-container>
  
                  
                        <ng-container matColumnDef="amount_payment">
                          <mat-header-cell *matHeaderCellDef mat-sort-header class="payment-amount"> {{ 'customerInvoiceDetail.payments.columns.amount' | translate }} ({{ currency }}) </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="amount_payment" class="payment-amount"> {{row.amount_payment}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef> {{ 'customerInvoiceDetail.payments.columns.actions' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="actions">
                            @if (canShowLegacyReceipt(row)) {
                              <button
                                mat-icon-button
                                type="button"
                                class="refund-receipt-button"
                                [attr.aria-label]="'customerInvoiceDetail.payments.viewRefundReceipt' | translate"
                                [matTooltip]="'customerInvoiceDetail.payments.viewRefundReceipt' | translate"
                                matTooltipPosition="above"
                                (click)="openRefundReceipt(row)">
                                <mat-icon>description</mat-icon>
                              </button>
                            }
                          </mat-cell>
                        </ng-container>
                    
                
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" >
                    </mat-row>
                </mat-table>
                </div>
                <mat-paginator showFirstLastButtons
                        [length]="tableService.pager.totalEntities"
                        [pageIndex]="tableService.pager.pageIndex"
                        [pageSize]="tableService.pager.pageSize"
                        [pageSizeOptions]="[20, 50, 100]"
                        (page)="list($event)">
                </mat-paginator>  
            </div>
            
        </div>

        <div class="reports-data">
            
            <h1>{{ 'customerInvoiceDetail.coupons.title' | translate }}</h1>
            <div style="padding-top: 2em;">
                <mat-table [dataSource]="dataCuponSource" matSort  >
                                 
                    <ng-container matColumnDef="cupon.id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.id' | translate }} </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="cupon.id"> {{row.cupon.id}} </mat-cell>
                      </ng-container>
                  
                      <ng-container matColumnDef="cupon.name_cupon">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.name' | translate }} </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="cupon.name_cupon"> {{row.cupon.name_cupon}} </mat-cell>
                      </ng-container>
  
                      <ng-container matColumnDef="cupon.value">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.value' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="cupon.value"> {{row.cupon.value}} </mat-cell>
                        </ng-container>
  
                        <ng-container matColumnDef="cupon.type">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.type' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="cupon.type"> {{row.cupon.type}} </mat-cell>
                        </ng-container>
  
                        <ng-container matColumnDef="cupon.status">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.status' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="cupon.status"> {{row.cupon.status}} </mat-cell>
                        </ng-container>
  
                  
                        <ng-container matColumnDef="cupon.createdAt">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoiceDetail.coupons.columns.created' | translate }} </mat-header-cell>
                          <mat-cell *matCellDef="let row" data-label="cupon.createdAt"> {{row.cupon.createdAt}} </mat-cell>
                        </ng-container>
                    
                
                        <mat-header-row *matHeaderRowDef="displayedCuponColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedCuponColumns;"  >
                        </mat-row>
                </mat-table>
                <mat-paginator showFirstLastButtons
                                [length]="tableCuponService.pager.totalEntities"
                                [pageIndex]="tableCuponService.pager.pageIndex"
                                [pageSize]="tableCuponService.pager.pageSize"
                                [pageSizeOptions]="[20, 50, 100]"
                                (page)="listCupon($event)">
                        </mat-paginator>  
            </div>
            
        </div>
        
        <div class="options-buttons">
          <button class="back-btn" (click)="goBack()" >{{ 'customerInvoiceDetail.buttons.back' | translate }}</button>
        </div>

    </div>
</body>
